import { connect } from 'react-redux'
import MobilityOptionsList from '../../components/mobility-options/MobilityOptionsList'
import { filterMobilityOptions } from '../../state/selectors/index'
import { IMobilityOptionObject, IStoreState } from '../../types'

export function mapStateToProps(
  state: IStoreState,
  ownProps: any
): { mobilityOptions: { [key: number]: IMobilityOptionObject } } {
  return {
    mobilityOptions:
      state.mobilityOptionsSearch.query === ''
        ? state.mobilityOptions.items
        : filterMobilityOptions(state, state.mobilityOptionsSearch.query)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobilityOptionsList)



// WEBPACK FOOTER //
// ./src/containers/mobility-options/MobilityOptionsList.tsx